export default "__VITE_ASSET__BN1l2DGV__"